import { useEffect, useState } from 'react';
import Title from 'src/components/atoms/Title/Title';
import Evaluation from 'src/components/molecules/Evaluation/Evaluation';
import FilterSection from 'src/components/molecules/FilterSection';
import ProjectCount from 'src/components/molecules/ProjectCount';
import ProjectListAndPagination from 'src/components/molecules/ProjectListAndPagination';
import ProjectSizeAndSorting from 'src/components/molecules/ProjectSizeAndSorting';
import useSelectedRegionHooks from 'src/hooks/useSelectedRegionHooks';

import {
  useShowFilterStore,
  useFilterSettingsStore,
  useProjectsOverviewStore,
  useWindowWidthStore,
  useLabels,
  useBaseUrlStore,
  useLanguageStore,
} from 'src/StoreDataProvider';
import WorldMap from '../../molecules/WorldMap';
import { ISOCode } from '../../molecules/WorldMap/worldMap.types';

const ProjectsOverview: () => JSX.Element = () => {
  const [chosenCountries, setChosenCountries] = useState<ISOCode[]>([]);
  const windowState = useWindowWidthStore();
  const [chosenCountriesByRegion, setChosenCountriesByRegion] = useState<
    ISOCode[]
  >([]);
  const showFilter = useShowFilterStore();
  const [filterView, setFilterView] = useState(false);
  const filterSettingStore = useFilterSettingsStore();
  const {
    actions: { getISOCodesBySelectedRegions },
  } = useSelectedRegionHooks();
  const { averageRating } = useProjectsOverviewStore();
  const labels = useLabels();
  const { isYearView } = useBaseUrlStore();
  const { language } = useLanguageStore();

  useEffect(() => {
    setFilterView(windowState.isMobileView && showFilter.showFilter);
  }, [showFilter]);

  useEffect(() => {
    setChosenCountries(filterSettingStore.country);
    setChosenCountriesByRegion(getISOCodesBySelectedRegions());
  }, [filterSettingStore]);

  useEffect(() => {
    document.title = isYearView
      ? labels.titleYearsView1
      : labels.titleDefaultView1;
  }, [labels.titleYearsView1, isYearView, language]);

  return (
    <div>
      {!filterView && <Title />}
      <div id="search" className="row search">
        <FilterSection />

        <div
          className="col-auto"
          style={{ display: filterView ? 'none' : 'block' }}
        >
          <section id="entryCount" className="row result-info">
            <div className="col-auto">
              <ProjectCount />
            </div>
          </section>
          <div className="row">
            <div className="col-auto">
              <section id="worldMap">
                <WorldMap
                  chosenCountries={chosenCountries}
                  chosenCountriesByRegion={chosenCountriesByRegion}
                />
              </section>
              <ProjectSizeAndSorting />
            </div>
            <aside className="col-auto search-evaluation-desktop">
              <Evaluation averageRating={averageRating} />
            </aside>
          </div>
          <section id="results">
            <ProjectListAndPagination />
          </section>
        </div>
      </div>
    </div>
  );
};

export default ProjectsOverview;
